var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography } from '@mui/material';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import UserLoginOtherAccountCard from './UserLoginOtherAccountCard';
var UserLoginHistoryForm = function (_a) {
    var userLoginHistory = _a.userLoginHistory, setValue = _a.setValue, setEmail = _a.setEmail, setUserLoginHistory = _a.setUserLoginHistory;
    var t = useTranslation().t;
    return (_jsx(Box, __assign({ sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: '32rem',
            minWidth: '15rem',
            width: '32rem',
            m: '2rem'
        } }, { children: _jsxs(Box, __assign({ sx: { mb: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center' } }, { children: [_jsx(Typography, __assign({ sx: { fontSize: { xs: '2rem', md: '2rem' }, fontWeight: 500, lineHeight: 1, paddingBottom: 4 } }, { children: t('Выберите аккаунт для входа') }), void 0), _jsx(Box, __assign({ sx: { mb: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 } }, { children: _.orderBy(userLoginHistory, 'lastActiveDate', 'desc').map(function (userLoginHistoryItem, index) {
                        return (_jsx(UserLoginOtherAccountCard, { userLoginHistory: userLoginHistoryItem, setEmail: setEmail, setValue: setValue, setUserLoginHistory: setUserLoginHistory }, index));
                    }) }), void 0), _jsx(Box, __assign({ sx: { mb: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center' } }, { children: _jsx(Button, __assign({ variant: "text", onClick: function () {
                            setEmail('');
                            setValue(1);
                        } }, { children: t('Войти в другой аккаунт') }), void 0) }), void 0)] }), void 0) }), void 0));
};
export default UserLoginHistoryForm;
